export const DOMAIN_GET = 'DOMAIN_GET';
export const DOMAINS_NAVIGATE = 'DOMAINS_NAVIGATE';
export const VALUE_COPY = 'VALUE_COPY';
export const DOMAIN_VERIFY = 'DOMAIN_VERIFY';
